import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSessionProfile } from './session';

// Loads the stored login profile - empty permissions until loaded
export function useSessionProfile() {
  const [profile, setProfile] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getSessionProfile()
      .then(setProfile)
      .catch(() => setProfile(null))
      .finally(() => setLoaded(true));
  }, []);

  return { loaded, profile, permissions: profile?.permissions ?? {} };
}

// Redirects to the profile page when the logged-in user lacks the given
// permission, so hidden screens stay unreachable even via deep links.
// Screens render their content only once allowed resolves true.
export function useRequirePermission(permission) {
  const navigate = useNavigate();
  const state = useSessionProfile();
  const allowed = !!state.permissions[permission];

  useEffect(() => {
    if (state.loaded && !allowed) {
      navigate('/warehouse/app/profile', { replace: true });
    }
  }, [state.loaded, allowed, navigate]);

  return { ...state, allowed };
}

// The first workflow the user can access - profile when they have no
// workflow permissions at all
export function homeRouteForPermissions(permissions) {
  if (permissions?.picker) return '/warehouse/app/picking';
  if (permissions?.packer) return '/warehouse/app/packing';
  if (permissions?.stock_return) return '/warehouse/app/returns';
  return '/warehouse/app/profile';
}

// Display labels for the roles this app shows
const ROLE_LABELS = [
  ['picker', 'Picker'],
  ['packer', 'Packer'],
  ['stock_return', 'Stock Returns'],
];

export function roleLabels(permissions) {
  return ROLE_LABELS.filter(([key]) => permissions?.[key]).map(([, label]) => label);
}
